@if (sideNavService.open()) {
  <div
    class="tw-relative tw-mt-1 tw-mx-2 tw-rounded-lg tw-border tw-border-solid tw-border-border-nav-divider tw-p-3 tw-text-sm tw-text-fg-nav-heading"
  >
    @if (isDismissible()) {
      <div class="tw-absolute tw-end-1 tw-top-1">
        <button
          type="button"
          bitIconButton="bwi-close"
          buttonType="unstyled"
          size="small"
          (click)="onDismiss()"
          [label]="'close' | i18n"
          class="tw-border-0 hover:tw-bg-bg-nav-hover focus-visible:!tw-ring-fg-nav focus-visible:!tw-ring-offset-bg-nav focus-visible:tw-bg-bg-nav-hover"
        ></button>
      </div>
    }
    <div [class.tw-pe-6]="isDismissible()">
      <ng-content></ng-content>
    </div>
  </div>
}
